export default "__VITE_ASSET__SCOfhvVz__"